module.exports = __webpack_public_path__ + "static/media/start_sound.48aa72dc.mp3";